import { initBlankLinks } from '@helpers/blank-links';

document.addEventListener('DOMContentLoaded', () => {
  initBlankLinks();
});
